import { ModelBase } from '../../core/model/model-base';

export class Address extends ModelBase {
  constructor(dataContext?: any) {
    super();
    this.country = 'SE';
    if (dataContext) {
      this.street = dataContext.street;
      this.city = dataContext.city;
      if (dataContext.country) this.country = dataContext.country;
      this.postalCode = dataContext.postalCode;
    }
  }

  street: string;
  city: string;
  country: string;
  postalCode: string;
}
